import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.195 3.529a.67.67 0 0 1 .472-.196h2.666A.667.667 0 0 1 10 4v.667H6V4c0-.177.07-.346.195-.471M5.326 6H12a.667.667 0 0 1 .667.667V12a.667.667 0 0 1-.667.667H4A.667.667 0 0 1 3.333 12V6.667A.667.667 0 0 1 4 6zm-.66-1.333V4a2 2 0 0 1 2-2h2.667a2 2 0 0 1 2 2v.667H12a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6.667a2 2 0 0 1 2-2zM6 9.333c0-.368.298-.666.667-.666h.666V8a.667.667 0 0 1 1.334 0v.667h.666a.667.667 0 1 1 0 1.333h-.666v.667a.667.667 0 1 1-1.334 0V10h-.666A.667.667 0 0 1 6 9.333",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })